import { useLocation, useNavigate } from "react-router";
import { TopBar } from "../common/TopBar";
import "./CheckEmailStyles.css";
import { GetImages } from "../../utils/GetImages";
import AddButtonWithArrow from "../firstTimeUserExperience/commonCom/AddButtonWithArrow";

const CheckEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state.key;

  const backToLogin = () => {
    navigate("/login");
  };

  return (
    <>
      <div className="background-section background-image">
        <TopBar haveAccount="Don’t have an account?" signInUp="Sign up" />
        <div className="form-container-main">
          <div className="form-container">
            <div className="correctImageContainer" >
              <img src={GetImages.success} />
            </div>
            <p className="resetLinkSentText top_header mb-1">Reset password link sent</p>
            <p className="resetLinkSubText sub_heading"> We have sent a reset password link on </p>
            <p className="emailtextStyles sub_heading ">{email && email}</p>
            <AddButtonWithArrow
              onClick={backToLogin}
              className="backtoLoginButton sub_heading"
              type="submit"
              buttonname={"Back to login"} 
              />
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckEmail;
